import React, { useState, useCallback, useRef, useEffect, useMemo } from 'react';

import DataGrid, { Selection, RowDragging, Column, Editing, Scrolling, Paging, Toolbar, Item, MasterDetail, Export, Summary, TotalItem, FilterRow } from 'devextreme-react/data-grid';
import LoadPanel from 'devextreme-react/load-panel';
import DropDownButton from 'devextreme-react/drop-down-button';
import Popup from 'devextreme-react/popup';
import TagBox from 'devextreme-react/tag-box';
import { withLoadPanel } from '../../../utils/withLoadPanel';
import TextBox from 'devextreme-react/text-box';
import './CardEntries.scss';

import { checkPermission } from '../../../permissions';
import { EditCellTimeComponent, EditCellTimeRender, editCellTimeRender, TimeBox, TimeBoxBold } from '../../utils/time-box/TimeBox';
import { Button, ButtonGroup, NumberBox } from 'devextreme-react';
import { PerformanceCell } from '../../utils/performance-cell/PerformanceCell';
import { useScreenSize } from '../../../utils/media-query';
import { COMPETITION_ATHLETE_STATUS_LIST, COMPETITION_STATUS_LIST, exportFormats } from '../../../shared/constants';
import { onExporting } from '../../../utils/exporter';
import { useNavigate } from 'react-router-dom';
import { FormEntryPopup } from '../../utils/form-entry-popup/FormEntryPopup';
import { EntryForm } from '../entry-form/EntryForm';
import { BatchEntryForm } from '../entry-batch-form/EntryBatchForm';
import { getApiToken } from '../../../utils/authUtils.js';
import axios from 'axios';
import notify from 'devextreme/ui/notify';
import { alert, confirm } from 'devextreme/ui/dialog';
import { CompetitionAthleteStatus } from '../../utils/competition-athlete-status/CompetitionAthleteStatus';
import { useMsal } from "@azure/msal-react";
import SelectBox from 'devextreme-react/select-box';
import { openPDFOnDevice } from '../../../utils/pdfUtils';


const Grid = ({ entries, competitionId, traininggroups, competition }) => {
      const { instance, accounts } = useMsal();
    let newEntryData;
    let newBatchEntryData;
    const calculateSummary = (options) => {
        if (options.name === "AthleteCount") {
            if (options.summaryProcess === "start") {
                options.totalValue = 0;
            }
            if (options.summaryProcess === "calculate") {
                if (options.value > 0) {
                    options.totalValue++;
                }
            }
        }
    }
    const [popupEntryVisible, setPopupEntryVisible] = useState(false);
    const [popupBatchEntryVisible, setPopupBatchEntryVisible] = useState(false);
    const [entryData, setEntryData] = useState({});
    const [entryBatchData, setBatchEntryData] = useState({});
    const [filterButton, setfilterButton] = useState([]);
    const [pdfLoading, setPdfLoading] = useState(false);
    const { isXSmall } = useScreenSize();
    const onDataChanged = useCallback((data) => {

        newEntryData = data;
    }, []);
 
    const onBatchDataChanged = useCallback((data) => {

        newBatchEntryData = data;
    }, []);
    const saveEntries = useCallback((e) => {
        getApiToken(instance, accounts).then((token) => {

            if (e != undefined) {
                newEntryData.status = e;
            }
            axios.post(`${process.env.REACT_APP_serverEndpoint}/Entry/SetEntriesAthleteCompetition`, newEntryData, {
                headers: {
                    'Authorization': "Bearer " + token
                }
            }).then((response) => {
                if (response.data.success == true) {

                    if (response.data.result_set == false) {
                        const message = response.data.userMessage || "Meldung konnte nicht gespeichert werden. Möchten Sie es trotzdem versuchen?";
                        if (message.includes("Speichern nicht möglich")) {
                            // Dialog anzeigen, aber Buttons verstecken
                            alert(message, "Speichern nicht möglich");
                        } else {
                            confirm(message, "Bestätigung").then((dialogResult) => {
                                if (dialogResult) {
                                    // Erneute Anfrage mit force = true
                                    axios.post(`${process.env.REACT_APP_serverEndpoint}/Entry/SetEntriesAthleteCompetition`,
                                        { ...newEntryData, force: true },
                                        {
                                            headers: {
                                                'Authorization': "Bearer " + token
                                            }
                                        }
                                    ).then((retryResponse) => {
                                        if (retryResponse.data.success == true) {
                                            notify({
                                                message: `Speichern der Meldungen erfolgreich`,
                                                position: { at: 'bottom center', my: 'bottom center' }
                                            }, 'success');
                                            setPopupEntryVisible(false);
                                            gridRef.current?.instance().getDataSource().reload();
                                        } else {
                                            notify({
                                                message: `Fehler beim erneuten Speichern der Meldungen`,
                                                position: { at: 'bottom center', my: 'bottom center' }
                                            }, 'error');
                                        }
                                    }).catch((error) => console.log(error));
                                }
                            });
                        }
                    } else {
                        notify({
                            message: `Speichern der Meldungen erfolgreich`,
                            position: { at: 'bottom center', my: 'bottom center' }
                        },
                            'success'
                        );
                        setPopupEntryVisible(false)
                        gridRef.current?.instance().getDataSource().reload();
                    }

                } else {
                    notify({
                        message: `Fehler beim Speichern der Meldungen`,
                        position: { at: 'bottom center', my: 'bottom center' }
                    },
                        'error'
                    );
                }

            }
            ).catch((error) => console.log(error));
        });



    }, []);
    const saveBatchEntries = useCallback((e) => {
        getApiToken(instance, accounts).then((token) => {

            if (e != undefined) {
                newBatchEntryData.status = e;
            }
            axios.post(`${process.env.REACT_APP_serverEndpoint}/Entry/SetEntriesCompetitionBatch`, newBatchEntryData, {
                headers: {
                    'Authorization': "Bearer " + token
                }
            }).then((response) => {
                if (response.data.success == true) {

                    if (response.data.result_set == false) {
                        const message = response.data.userMessage || "Meldung konnte nicht gespeichert werden. Möchten Sie es trotzdem versuchen?";
                        confirm(message, "Bestätigung").then((dialogResult) => {
                            if (dialogResult) {
                                // Erneute Anfrage mit force = true
                                axios.post(`${process.env.REACT_APP_serverEndpoint}/Entry/SetEntriesCompetitionBatch`,
                                    { ...newBatchEntryData, force: true },
                                    {
                                        headers: {
                                            'Authorization': "Bearer " + token
                                        }
                                    }
                                ).then((retryResponse) => {
                                    if (retryResponse.data.success == true) {
                                        notify({
                                            message: `Speichern der Meldungen erfolgreich`,
                                            position: { at: 'bottom center', my: 'bottom center' }
                                        }, 'success');
                                        setPopupBatchEntryVisible(false);
                                        gridRef.current?.instance().getDataSource().reload();
                                    } else {
                                        notify({
                                            message: `Fehler beim erneuten Speichern der Meldungen`,
                                            position: { at: 'bottom center', my: 'bottom center' }
                                        }, 'error');
                                    }
                                }).catch((error) => console.log(error));
                            }
                        });
                    } else {
                        notify({
                            message: `Speichern der Meldungen erfolgreich`,
                            position: { at: 'bottom center', my: 'bottom center' }
                        },
                            'success'
                        );
                        setPopupBatchEntryVisible(false)
                        gridRef.current?.instance().getDataSource().reload();
                    }

                } else {
                    notify({
                        message: `Fehler beim Speichern der Meldungen`,
                        position: { at: 'bottom center', my: 'bottom center' }
                    },
                        'error'
                    );
                }

            }
            ).catch((error) => console.log(error));
        });



    }, []);
    const changePopupEntryVisibility = useCallback((isVisble) => {
        setPopupEntryVisible(isVisble);
    }, []);
    const changePopupBatchEntryVisibility = useCallback((isVisble) => {
        setPopupBatchEntryVisible(isVisble);
    }, []);
    const rowPrepared = (e) => {
        if (e.rowType === "data") {
            if (e.data.entriesAvailable == 0) {
                e.rowElement.classList.add('disabled-rows');
                e.rowElement.className = e.rowElement.className.replace("dx-row-alt", "");
            }
        }
    }

    const EntryFormWithLoadPanel = withLoadPanel(EntryForm);
    const BatchEntryFormWithLoadPanel = withLoadPanel(BatchEntryForm);
    const cellNameRender = (cell) => (

        <div>{cell.data.lastname}, {cell.data.surname} </div>

    );
    const [gridData, setGridData] = useState(entries);
    const [athleteStatus, setAthleteStatus] = useState();
    const [batchEntries, setbatchEntries] = useState(false);
    const [filterStatusList, setfilterStatusList] = useState(['alle', ...traininggroups.map((group) => group.groupname)]);
    const traininggroupNames = useMemo(() => traininggroups?.map((group) => group.groupname) || [], [traininggroups]);
    const dropDownOptions = { width: 'auto' };
    const handleInitNewRow = (e) => {
        e.data.competitionId = competitionId;
    };
    const gridRef = useRef(null);
    var traininggroupName = JSON.parse(localStorage.getItem('traininggroupName'));
    const [status, setStatus] = useState(traininggroupName != null ? traininggroupName : filterStatusList[0]);
    const navigate = useNavigate();
    useEffect(() => {
        if (status !== 'alle') {
            gridRef.current?.instance().filter([['groupname', '=', status], "AND", ["competitionId", "=", competitionId]]);
        }

    }, []);
    const pdfItems = [
        { key: 'entries', text: 'Meldeliste (pro Sportler)', icon: 'exportpdf' },
        { key: 'starting', text: 'Startliste (pro Wettkampf)', icon: 'exportpdf' }
    ];
    const [pdfSelectionVisible, setPdfSelectionVisible] = useState(false);
    const [selectedPdfVariant, setSelectedPdfVariant] = useState('entries');
    const [selectedPdfGroups, setSelectedPdfGroups] = useState([]);
    const [selectedExportFormat, setSelectedExportFormat] = useState('pdf');

    const downloadExport = useCallback(async (variant, groupNames, format) => {
        const groupsToSend = groupNames?.length
            ? groupNames
            : (status === 'alle' ? traininggroupNames : [status].filter(Boolean));

        if (!groupsToSend.length) {
            notify({
                message: 'Bitte mindestens eine Gruppe auswählen.',
                position: { at: 'bottom center', my: 'bottom center' }
            }, 'warning');
            return;
        }

        try {
            setPdfLoading(true);
            const token = await getApiToken(instance, accounts);
            const isExcel = format === 'excel';
            const endpoint = (() => {
                if (variant === 'starting') {
                    return isExcel ? 'ReportStartingListAsExcel' : 'ReportStartingListAsPdf';
                }
                return isExcel ? 'ReportEntriesAsExcel' : 'ReportEntriesAsPdf';
            })();
            const response = await axios.post(
                `${process.env.REACT_APP_serverEndpoint}/Entry/${endpoint}`,
                { competitionId, groupnames: groupsToSend },
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    },
                    responseType: 'blob'
                }
            );

            const blob = new Blob([response.data], { type: isExcel ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' : 'application/pdf' });
            const fileName = `${variant === 'starting' ? 'Startliste' : 'Meldungen'}_${competitionId}.${isExcel ? 'xlsx' : 'pdf'}`;

            await openPDFOnDevice(blob, fileName);
        } catch (error) {
            console.error('Error downloading export:', error);
        } finally {
            setPdfLoading(false);
        }
    }, [competitionId, instance, accounts, status, traininggroupNames]);

    const onPDFClick = useCallback((e) => {
        if (pdfLoading) {
            return;
        }

        const variant = e.itemData?.key || 'entries';
        const defaultGroups = status === 'alle' ? traininggroupNames : [status].filter(Boolean);

        setSelectedPdfVariant(variant);
        setSelectedPdfGroups(defaultGroups.length ? defaultGroups : traininggroupNames);
        setPdfSelectionVisible(true);
    }, [pdfLoading, status, traininggroupNames]);

    const onConfirmPdfSelection = useCallback(() => {
        if (!selectedPdfGroups.length) {
            notify({
                message: 'Bitte mindestens eine Gruppe auswählen.',
                position: { at: 'bottom center', my: 'bottom center' }
            }, 'warning');
            return;
        }
        setPdfSelectionVisible(false);
        downloadExport(selectedPdfVariant, selectedPdfGroups, selectedExportFormat);
    }, [downloadExport, selectedPdfGroups, selectedPdfVariant, selectedExportFormat]);

    const onCancelPdfSelection = useCallback(() => {
        setPdfSelectionVisible(false);
    }, []);
    const filterByStatus = useCallback((e) => {
        const { item: status } = e;

        if (status === 'alle') {
            gridRef.current?.instance().filter(["competitionId", "=", competitionId]);
        } else {
            gridRef.current?.instance().filter([['groupname', '=', status], "AND", ["competitionId", "=", competitionId]]);
        }


        setStatus(status);
    }, []);
    const filterByButton = (e) => {
        const text = e.itemData.hint;

        if (!filterButton.includes(text)) {
            setfilterButton([...filterButton, text]); // Text hinzufügen, wenn er nicht existiert
        } else {
            setfilterButton(filterButton.filter((item) => item !== text)); // Text entfernen, wenn er bereits existiert
        }

        

        switch (e.itemData.hint) {
            case 'offen':


                if (athleteStatus == text) { setAthleteStatus(); } else { setAthleteStatus(text); }
                break;
            case 'Sammelmeldung':

                setbatchEntries(!batchEntries)
                break;

        }

    }
    const onCellClick = useCallback((e) => {

        if (e.rowType === 'data' && e.column.type != 'selection') {

            //LoadEntrieData  e.data.competitionId, e.data.athleteId
            getApiToken(instance, accounts).then((token) => {
                axios.get(`${process.env.REACT_APP_serverEndpoint}/Entry/GetEntriesAthleteCompetition?athleteId=` + e.data.athleteId.toString() + '&competitionId=' + e.data.competitionId.toString(), {
                    headers: {
                        'Authorization': "Bearer " + token
                    }
                }).then((response) => {
                    if (response.data.success == true) {
                        newEntryData = response.data.result_set;
                        setEntryData(response.data.result_set)
                        setPopupEntryVisible(true);

                    } else {
                        notify({
                            message: `Fehler beim Laden der Meldungen`,
                            position: { at: 'bottom center', my: 'bottom center' }
                        },
                            'error'
                        );
                    }

                }
                ).catch((error) => console.log(error));
            });


        }
    }, []);
    const onAthleteStatusChanged = useCallback((e) => {
        if (e.itemData.text === "keine Teilnahme") {
            const message = "Möchten Sie den Status wirklich auf 'Keine Teilnahme' setzen und alle Meldungen für diesen Sportler löschen?";
            confirm(message, "Bestätigung").then((dialogResult) => {
                if (dialogResult) {
                    getApiToken(instance, accounts).then((token) => {
                        newEntryData.status = e.itemData.text;
                        axios.post(`${process.env.REACT_APP_serverEndpoint}/Entry/SetStatusAthleteCompetition`, newEntryData, {
                            headers: {
                                'Authorization': "Bearer " + token
                            }
                        }).then((response) => {
                            if (response.data.success == true) {
                                notify({
                                    message: `Status erfolgreich auf 'Keine Teilnahme' gesetzt und alle Meldungen gelöscht.`,
                                    position: { at: 'bottom center', my: 'bottom center' }
                                }, 'success');
                                setPopupEntryVisible(false);
                                gridRef.current?.instance().getDataSource().reload();
                            } else {
                                notify({
                                    message: `Fehler beim Setzen des Status.`,
                                    position: { at: 'bottom center', my: 'bottom center' }
                                }, 'error');
                            }
                        }).catch((error) => console.log(error));
                    });
                }
            });
        } else {
            getApiToken(instance, accounts).then((token) => {
                newEntryData.status = e.itemData.text;
                axios.post(`${process.env.REACT_APP_serverEndpoint}/Entry/SetStatusAthleteCompetition`, newEntryData, {
                    headers: {
                        'Authorization': "Bearer " + token
                    }
                }).then((response) => {
                    if (response.data.success == true) {
                        notify({
                            message: `Status erfolgreich geändert.`,
                            position: { at: 'bottom center', my: 'bottom center' }
                        }, 'success');
                        setPopupEntryVisible(false);
                        gridRef.current?.instance().getDataSource().reload();
                    } else {
                        notify({
                            message: `Fehler beim Ändern des Status.`,
                            position: { at: 'bottom center', my: 'bottom center' }
                        }, 'error');
                    }
                }).catch((error) => console.log(error));
            });
        }

    }, []);
    const onSammelEntryClick = useCallback((e) => {

        const selectedRows = gridRef.current?.instance().getSelectedRowsData(); // Alle ausgewählten Zeilen abrufen

        if (!selectedRows || selectedRows.length === 0) {
            notify({
                message: `Bitte wählen Sie mindestens eine Zeile aus.`,
                position: { at: 'bottom center', my: 'bottom center' }
            }, 'warning');
            return;
        }
        var postData = { competitionId: competitionId, athletes: selectedRows }

        getApiToken(instance, accounts).then((token) => {
            axios.post(`${process.env.REACT_APP_serverEndpoint}/Entry/GetEntriesCompetitionBatch`, postData, {
                headers: {
                    'Authorization': "Bearer " + token
                }
            }).then((response) => {
                if (response.data.success == true) {
                    newBatchEntryData = response.data.result_set;
                    setBatchEntryData(response.data.result_set)
                    setPopupBatchEntryVisible(true);

                } else {
                    notify({
                        message: `Fehler beim Laden der Meldungen`,
                        position: { at: 'bottom center', my: 'bottom center' }
                    },
                        'error'
                    );
                }
            }).catch((error) => console.log(error));
        });

    }, []);
    const editCellStatusRender = () => (
        <SelectBox className='cell-info' dataSource={COMPETITION_ATHLETE_STATUS_LIST} itemRender={statusItemRender} />
    );
    const statusItemRender = (text) => <CompetitionAthleteStatus text={text} />;
    return (
        <div className='entries-card'>
            <DataGrid
                className='entries-grid'
                dataSource={gridData}
                remoteOperations={true}
                width={'100%'}
                height={'calc(100vh - 250px)'}
                onInitNewRow={handleInitNewRow}
                rowAlternationEnabled={true}
                onExporting={onExporting}
                ref={gridRef}
                onCellClick={onCellClick}
                onRowPrepared={rowPrepared}
            //  columnAutoWidth={useScreenSize() === 'xs'}
            >
                <FilterRow visible={batchEntries} />
                <Export enabled formats={exportFormats} />
                <Paging enabled={false} />
                <Selection mode={batchEntries ? 'multiple' : 'none'} showCheckBoxesMode='always' />


                {/* <Editing mode="cell" allowAdding={false} allowDeleting={false} allowUpdating={checkPermission('entry.edit')} /> */}
                <Toolbar>
                    <Item location='before'>
                        <Button
                            icon='plus'
                            //  text='Sammelmeldung hinzufügen'
                            type='default'
                            stylingMode='contained'
                            visible={batchEntries && checkPermission('entry.add')}
                            onClick={onSammelEntryClick}
                        />
                    </Item>
                    <Item location='before'>
                        <ButtonGroup
                            items={[{ hint: 'offen', icon: 'eyeopen' }, { hint: 'Sammelmeldung', icon: 'group' },]}
                            stylingMode="text"
                            keyExpr="hint"
                            selectionMode="multiple"
                            onItemClick={filterByButton}
                            cssClass='group-margin'
                            defaultSelectedItemKeys={filterButton}
                            visible={checkPermission('entry.add')}
                        />
                    </Item>
                    <Item location='after' locateInMenu='auto'>
                        <DropDownButton
                            icon='exportpdf'
                            stylingMode='text'
                            items={pdfItems}
                            keyExpr='key'
                            displayExpr='text'
                            useSelectMode
                            disabled={pdfLoading}
                            onItemClick={onPDFClick}
                            dropDownOptions={{ width: 280 }}
                        />
                    </Item>

                    <Item location='after' locateInMenu='auto'>
                        <DropDownButton
                            items={filterStatusList}
                            stylingMode='text'
                            text={status}
                            dropDownOptions={dropDownOptions}
                            useSelectMode
                            onSelectionChanged={filterByStatus}
                            visible={competitionId !== undefined}
                        />
                    </Item>

                </Toolbar>

                <Column
                    dataField='athletename'
                    caption='Sportler'
                    width={0}
                    allowEditing={false}

                />

                <Column
                    dataField='lastname'
                    caption='Name'
                    sortOrder='asc'
                    hidingPriority={5}
                    minWidth={80}
                    width={isXSmall ? 120 : null}
                    cellRender={cellNameRender}
                    dataType='string'
                />
                <Column
                    dataField='surname'
                    caption='Vorname'
                    visible={false}
                    dataType='string'
                />
                <Column dataField="dateofbirth" caption="Geburtstag" dataType="date" format="dd.MM.yyyy" hidingPriority={2} allowHiding={true} />

                <Column dataField="gender" caption="Geschlecht" dataType='string' hidingPriority={1} allowHiding={true} lookup={{ dataSource: [{ value: 0, text: "männlich" }, { value: 1, text: "weiblich" }, { value: 2, text: "divers" }], valueExpr: 'value', displayExpr: 'text' }} />
                <Column dataField="entries" caption="Meldungen" dataType='number' width={isXSmall ? 25 : null} hidingPriority={4} />
                <Column dataField="entriesAvailable" caption="Mögliche Strecken" dataType='number' hidingPriority={0} />
                <Column
                    dataField='status'
                    caption='Status'
                    dataType='string'
                    width={isXSmall ? 50 : null}
                    hidingPriority={3}
                    filterValue={athleteStatus}
                    cellRender={CompetitionAthleteStatus}
                    editCellRender={editCellStatusRender}

                />
                <Summary>
                    <TotalItem
                        column="entries"
                        name="AthleteCount"
                        summaryType="custom"
                        showInColumn="entries"
                        displayFormat="Sportler: {0}" />
                    <TotalItem
                        column="entries"
                        summaryType="sum"
                        displayFormat="Meldungen: {0}" />
                </Summary>

            </DataGrid>
            <Popup
                title='Export konfigurieren'
                visible={pdfSelectionVisible}
                onHiding={onCancelPdfSelection}
                dragEnabled={false}
                hideOnOutsideClick={true}
                showCloseButton={true}
                width={420}
                height='auto'
            >
                <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                    <TagBox
                        dataSource={traininggroupNames}
                        value={selectedPdfGroups}
                        onValueChanged={(e) => setSelectedPdfGroups(e.value)}
                        showSelectionControls
                        applyValueMode='instantly'
                        multiline={true}
                        placeholder='Gruppen auswählen'
                    />
                    <SelectBox
                        items={[{ key: 'pdf', text: 'PDF' }, { key: 'excel', text: 'Excel' }]}
                        displayExpr='text'
                        valueExpr='key'
                        value={selectedExportFormat}
                        onValueChanged={(e) => setSelectedExportFormat(e.value)}
                        label='Exportformat'
                        labelMode='floating'
                    />
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                        <Button stylingMode='outlined' text='Abbrechen' onClick={onCancelPdfSelection} />
                        <Button
                            type='default'
                            text='Export starten'
                            onClick={onConfirmPdfSelection}
                            disabled={!selectedPdfGroups.length || pdfLoading}
                        />
                    </div>
                </div>
            </Popup>
            <LoadPanel
                shadingColor="rgba(0,0,0,0.4)"
                visible={pdfLoading}
                showIndicator={true}
                showPane={true}
                shading={true}
                message="PDF wird erstellt..."
                position={{ of: '.entries-card' }}
            />
            <FormEntryPopup title={`${entryData.athleteName + ' - ' + entryData.competitionName || ''}`} width={900} height={'calc(100vh - 160px)'} visible={popupEntryVisible} setVisible={changePopupEntryVisibility} isSaveVisible={competition?.status === 'Meldung möglich'} onSave={saveEntries} saveWithoutClosing={true} >
                <EntryFormWithLoadPanel hasData={true} loading={false} onDataChanged={onDataChanged} initData={entryData} allowEditing={competition?.status === 'Meldung möglich'} athleteStatusChanged={onAthleteStatusChanged} />
            </FormEntryPopup>
            <FormEntryPopup title='Meldungen bearbeiten' width={900} height={'calc(100vh - 160px)'} visible={popupBatchEntryVisible} setVisible={changePopupBatchEntryVisibility} isSaveVisible={competition?.status === 'Meldung möglich'} onSave={saveBatchEntries} saveWithoutClosing={true} >
                <BatchEntryFormWithLoadPanel hasData={true} loading={false} onDataChanged={onBatchDataChanged} initData={entryBatchData} allowEditing={competition?.status === 'Meldung möglich'} />
            </FormEntryPopup>
        </div>
    );
};

const GridWithLoadPanel = withLoadPanel(Grid);

export const CardEntries = ({ entries, isLoading, competitionId, traininggroups, competition }) => {
    
    return (
        <div className='card-entries'>
            <GridWithLoadPanel
                entries={entries}
                hasData={!!entries}
                loading={isLoading}
                competitionId={competitionId}
                traininggroups={traininggroups}
                competition={competition}
                panelProps={{
                    container: '.card-entries',
                    position: { of: '.card-entries' }
                }}
            />
        </div>
    );
};


